import Vue from 'vue'
import Vuex from 'vuex'
import graphDatasets from './modules/graphDatasets'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    graphDatasets
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js